import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { ClipLoader } from "react-spinners";
import axiosClient from "../../api/axios";

const carouselOptions = {
  autoplay: true,
  loop: true,
  margin: 15,
  dots: true,
  slidetransition: "linear",
  autoplayTimeout: 4500,
  autoplayHoverPause: true,
  autoplaySpeed: 4500,
  responsive: {
    0: { items: 2 },
    500: { items: 3 },
  },
};

export default function PartnersCarousel({ hasBg }) {
  const [settings, setSettings] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axiosClient.get("/api/our-partners/settings/").then((r) => setSettings(r.data.data)),
      axiosClient.get("/api/our-partners/images/").then((r) => setImages(r.data.data || [])),
    ]).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <section style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <ClipLoader color="#0d6efd" size={80} />
      </section>
    );
  }

  if (!settings) return null;

  return (
    <section className={`client-section ptb-100 ${hasBg ? "gray-light-bg" : ""}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="section-heading mb-5">
              <h2 className="text-center">{settings.section1_title}</h2>
              {settings.section1_descriptions.map((desc, i) => (
                <p key={i} style={{ fontSize: "1.2rem" }}>{desc}</p>
              ))}
            </div>
          </div>
        </div>
        {images.length > 0 && (
          <div className="row align-items-center">
            <div className="col-md-12">
              <OwlCarousel
                className="owl-carousel owl-theme clients-carousel dot-indicator"
                {...carouselOptions}
              >
                {images.map((img) => (
                  <div key={img.id} className="item single-client">
                    <img src={img.image_url} alt="partner logo" className="client-img" />
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
